var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 1.33331H3.99984C3.64622 1.33331 3.30708 1.47379 3.05703 1.72384C2.80698 1.97389 2.6665 2.31302 2.6665 2.66665V13.3333C2.6665 13.6869 2.80698 14.0261 3.05703 14.2761C3.30708 14.5262 3.64622 14.6666 3.99984 14.6666H11.9998C12.3535 14.6666 12.6926 14.5262 12.9426 14.2761C13.1927 14.0261 13.3332 13.6869 13.3332 13.3333V5.99998M8.6665 1.33331L13.3332 5.99998M8.6665 1.33331V5.99998H13.3332",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.b0b98e0a7aa75ed19b164ca121dedf88.svg";
export { ForwardRef as ReactComponent };